// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main_header.hide[data-v-2fd8e256]{transform:translate3d(0, -100%, 0) !important}\n", "",{"version":3,"sources":["webpack://./src/components/header/BaseHeader.vue"],"names":[],"mappings":"AACA,mCACE,6CAA8C","sourcesContent":["\n.main_header.hide {\n  transform: translate3d(0, -100%, 0) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
